import React from 'react';
import { Workout } from '../types';

interface MultipleWorkoutsSlotProps {
  workouts: Workout[];
  date: Date;
  hour: number;
  onClick?: (date: Date, hour: number) => void;
}

const MultipleWorkoutsSlot: React.FC<MultipleWorkoutsSlotProps> = ({
  workouts,
  date,
  hour,
  onClick
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick(date, hour);
    }
  };

  const formatTime = (hour: number): string => {
    return `${hour.toString().padStart(2, '0')}:00`;
  };

  const getWorkoutColor = (): string => {
    const hasCompleted = workouts.some(w => w.is_completed);
    const allCompleted = workouts.every(w => w.is_completed);

    if (allCompleted) {
      return 'bg-green-50 text-green-700 border border-green-200';
    } else if (hasCompleted) {
      return 'bg-yellow-50 text-yellow-700 border border-yellow-200';
    }
    return 'bg-yellow-50 text-yellow-700 border border-yellow-200';
  };

  const getWorkoutCountText = (count: number): string => {
    if (count === 1) return '1 тренировка';
    if (count >= 2 && count <= 4) return `${count} тренировки`;
    return `${count} тренировок`;
  };

  return (
    <div
      onClick={handleClick}
      className={`rounded-none cursor-pointer transition-all hover:shadow-sm text-xs h-full flex flex-col items-center justify-center ${getWorkoutColor()}`}
      title={`${workouts.length} тренировок в ${formatTime(hour)}\n\nКлиенты:\n${workouts.map(w => w.clients.map(c => `${c.first_name} ${c.last_name}`).join('\n')).join('\n')}`}
    >
      {/* Время */}
      <div className="text-center font-medium leading-tight">
        {formatTime(hour)}
      </div>
      
      {/* Количество тренировок */}
      <div className="text-center leading-tight font-bold">
        {getWorkoutCountText(workouts.length)}
      </div>

      {/* Статус завершения */}
      {workouts.every(w => w.is_completed) && (
        <div className="mt-0.5">
          <span className="inline-block w-1.5 h-1.5 bg-green-500 rounded-full"></span>
        </div>
      )}
    </div>
  );
};

export default MultipleWorkoutsSlot; 